import { Provider } from '@kyruus/search-sdk';

import { MarketableLocation } from '../../types';

export function getProviderLocationIdsByPrimaryLocation(
  providers: Provider[],
  primaryLocationId = ''
): number[] {
  const providerLocationIds = new Set<number>();

  providers
    .flatMap((p) => p.locations)
    .forEach((location) => {
      // TODO: Fix incorrect number type on @kyruus/search-sdk/LocationResult.primary_marketable_location_id
      if (
        (location?.primary_marketable_location_id as unknown as string) ===
        primaryLocationId
      ) {
        providerLocationIds.add(location.id);
      }
    });

  return [...providerLocationIds];
}

export const getContactForLocation = (
  location: MarketableLocation,
  contactType: string = 'phone'
): string | undefined => {
  const selectedContact = location.contacts?.find(
    (contact) => contact.contact_type === contactType
  );

  return selectedContact?.value;
};
